export const infoBlockEPGDescriptionBlockMore = {
  0: 2,
  767: 3,
  1240: 4,
}

export const infoBlockEPGDescriptionTitle = {
  0: 2,
  1240: 1,
}

export const PosterState = {
  Idle: 1 << 0,
  Loading: 1 << 1,
  Error: 1 << 2,
} as const
export type PosterState = (typeof PosterState)[keyof typeof PosterState]

export const THEME_WRAPPER_CLASSNAME = 'themeWrapperClassName'
